const setupFlashcards = (root: HTMLElement): void => {
    const slides = Array.from(root.querySelectorAll<HTMLElement>('[data-flashcards-slide]'));
    const previousButton = root.querySelector<HTMLButtonElement>('[data-flashcards-prev]');
    const nextButton = root.querySelector<HTMLButtonElement>('[data-flashcards-next]');
    const counter = root.querySelector<HTMLElement>('[data-flashcards-counter]');
    const totalSlides = slides.length;

    if (totalSlides === 0) {
        return;
    }

    let currentSlide = 0;
    let startX = 0;
    let endX = 0;
    let startY = 0;
    let endY = 0;
    let didSwipe = false;

    const resetFlippedCards = (): void => {
        root.querySelectorAll<HTMLElement>('.msj-flashcard.is-flipped').forEach(card => {
            card.classList.remove('is-flipped');
        });
    };

    const updateCounter = (): void => {
        if (counter) {
            counter.textContent = `Slide ${currentSlide + 1} de ${totalSlides}`;
        }
    };

    const updateArrows = (): void => {
        if (previousButton) {
            previousButton.classList.toggle('is-disabled', currentSlide === 0);
        }

        if (nextButton) {
            nextButton.classList.toggle('is-disabled', currentSlide === totalSlides - 1);
        }
    };

    const updateSlides = (): void => {
        slides.forEach((slide, index) => {
            slide.classList.toggle('is-active', index === currentSlide);
        });

        updateCounter();
        updateArrows();
    };

    const nextSlide = (): void => {
        if (currentSlide >= totalSlides - 1) {
            return;
        }

        resetFlippedCards();
        currentSlide += 1;
        updateSlides();
    };

    const previousSlide = (): void => {
        if (currentSlide <= 0) {
            return;
        }

        resetFlippedCards();
        currentSlide -= 1;
        updateSlides();
    };

    previousButton?.addEventListener('click', previousSlide);
    nextButton?.addEventListener('click', nextSlide);

    root.querySelectorAll<HTMLElement>('[data-flashcard]').forEach(card => {
        card.addEventListener('click', event => {
            if (didSwipe) {
                event.preventDefault();
                return;
            }

            card.classList.toggle('is-flipped');
        });

        card.addEventListener('keydown', event => {
            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }

            event.preventDefault();
            card.classList.toggle('is-flipped');
        });
    });

    root.addEventListener(
        'touchstart',
        event => {
            if (!event.touches || event.touches.length === 0) {
                return;
            }

            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            endX = startX;
            endY = startY;
        },
        { passive: true },
    );

    root.addEventListener(
        'touchmove',
        event => {
            if (!event.touches || event.touches.length === 0) {
                return;
            }

            endX = event.touches[0].clientX;
            endY = event.touches[0].clientY;
        },
        { passive: true },
    );

    root.addEventListener('touchend', () => {
        const diffX = startX - endX;
        const diffY = startY - endY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 45) {
            didSwipe = true;
            if (diffX > 0) {
                nextSlide();
            } else {
                previousSlide();
            }

            window.setTimeout(() => {
                didSwipe = false;
            }, 120);
            return;
        }

        didSwipe = false;
    });

    updateSlides();
};

export const initFlashcards = (): void => {
    document.querySelectorAll<HTMLElement>('[data-flashcards]').forEach(setupFlashcards);
};
